import { required } from 'vuelidate/lib/validators'
import countryRegister from '@/utils/customValidators/countryRegister'

export default {
  credentials: {
    countryregister: {
      required,
      countryRegister
    },
    password: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/login/company/resources/validations.js